(ns rothko.editor.behaviours.double-click
  (:require [clojure.string :as str]
            [com.rpl.specter :as sp]
            [rothko.editor.document.navigators :as n]
            [rothko.editor.matcher :as m]
            [rothko.editor.space.transform :as space-transform]))

(def words-then-spaces-regex #"\S+\s+")

(def transform
  (sp/cond-path
   ;; If the double click was on a word span, force the selection to be exactly
   ;; the width of the span. This is the normal behaviour in macOS, but not in Windows.
   [(n/context? [m/?any
                 (m/fn-matcher (fn [selected-tokens]
                                 (->> selected-tokens
                                      (map :word)
                                      (str/join)
                                      (re-matches words-then-spaces-regex))))
                 m/?any])]
   [(space-transform/remove-trailing-space-from-selection #{:space :space-edit} true)
    (sp/terminal identity)]
   
   n/CARET?
   (n/expand-selection
    {:new-start-offset 0
     :new-end-offset :last})))
